import { getRewardSummaryActionCreator } from 'actions/bountyActions'
import { SimpleGuard } from 'interfaces/guards'
import { rewardSummarySelector } from 'selectors/bountySelectors'

export const rewardsSummaryGuard: SimpleGuard = {
  name: `Rewards Summary Guard`,
  checker: (state): boolean => {
    return rewardSummarySelector(state) !== null
  },
  loader: (dispatch) => {
    dispatch(getRewardSummaryActionCreator.request({}))
  },
}
